<template>
  <div class="pco-painel">
    <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"800px"'

    :cpntOnFecharDialog='pcoPainelFormFechar'>
      <template slot='titulo'>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        Detalhes do Processo {{ registro[0] }}
      </template>

      <template slot='conteudo'>
        <template v-if="Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1">
          <template v-if="Object.keys(pcoItemDados).length >= 1">
            <table :data-time="time">
              <tr>
                <td class="venda">
                  <div v-html="(pcoItemDados.status === '2' ? 'Venda' : 'Orçamento') + ':'"></div>

                  <RF-Button class="bt-link-cadastro font-tp-1"
                    :cpntId='"RF-Tabela-Vue--link_venda--" + pcoItemDados.cod_venda'
                    :cpntStatus='""' 
                    :cpntTipo='"texto"'
                    :cpntClass='[ "btn", "btn-default" ]'

                    @onClickButton='pcoPainelFormInformacoesCadastro'>
                    <template slot="conteudo">
                      <div v-html="pcoItemDados.cod_venda" class="font-tp-1"></div>
                    </template>
                  </RF-Button>
                </td>

                <td colspan="1">
                  Contato: 
                  <RF-Button class="bt-link-cadastro font-tp-1"
                    :cpntId='"RF-Tabela-Vue--link-contato--" + pcoItemDados.id_con'
                    :cpntStatus='""'
                    :cpntTipo='"texto"'
                    :cpntClass='[ "btn", "btn-default" ]'

                    @onClickButton='pcoPainelFormInformacoesCadastro'>
                    <template slot="conteudo">
                    <!-- COLOCA O NOME DO CONTATO -->
                    <span v-html="pcoItemDados.id_con_nome"></span>

                    <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
                    <span v-if='pcoItemDados.id_con_pessoa === "j" && pcoItemDados.id_con_empresa !== ""' v-html="' (' + pcoItemDados.id_con_empresa + ')'"></span>

                    <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                    <b v-if='pcoItemDados.id_con_status !== "1"' v-html="'[Excluído]'"></b>
                    </template>
                  </RF-Button>
                </td>

                <td v-if="[ '', '0' ].indexOf(pcoItemDados.id_pet) === -1">
                  Pet: 
                  <RF-Button class="bt-link-cadastro font-tp-1"
                    :cpntId='"RF-Tabela-Vue--link-pet--" + pcoItemDados.id_pet'
                    :cpntStatus='""' 
                    :cpntTipo='"texto"'
                    :cpntClass='[ "btn", "btn-default" ]'

                    @onClickButton='pcoPainelFormInformacoesCadastro'>
                    <template slot="conteudo">
                      <!-- COLOCA O NOME DO CONTATO -->
                      <span v-html="pcoItemDados.id_pet_nome"></span>

                      <!-- COLOCA O NOME DO CONTATO -->
                      <span v-if="[ '', null, undefined ].indexOf(pcoItemDados.id_pet_subespecie_nome) === -1" v-html="' (' + pcoItemDados.id_pet_subespecie_nome + ')'"></span>

                      <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                      <b v-if='pcoItemDados.id_pet_status !== "1"' v-html="'[Excluído]'"></b>
                    </template>
                  </RF-Button>
                </td>

                <td v-if="[ '', '0' ].indexOf(pcoItemDados.id_vei) === -1">
                  Veículo: 
                  <RF-Button class="bt-link-cadastro font-tp-1"
                    :cpntId='"RF-Tabela-Vue--link-veiculo--" + pcoItemDados.id_vei'
                    :cpntStatus='""' 
                    :cpntTipo='"texto"'
                    :cpntClass='[ "btn", "btn-default" ]'

                    @onClickButton='pcoPainelFormInformacoesCadastro'>
                    <template slot="conteudo">
                      <!-- COLOCA O NOME DO CONTATO -->
                      <span v-html="pcoItemDados.id_vei_placa"></span>

                      <!-- COLOCA O MODELO NOVO DA API -->
                      <template v-if="[ '', null, undefined ].indexOf(pcoItemDados.id_vei_marca) === -1 || [ '', null, undefined ].indexOf(pcoItemDados.id_vei_modelo) === -1">
                        <span v-if="[ '', null, undefined ].indexOf(pcoItemDados.id_vei_marca) === -1" v-html="' ' + pcoItemDados.id_vei_marca"></span>
                        <span v-if="[ '', null, undefined ].indexOf(pcoItemDados.id_vei_modelo) === -1" v-html="' ' + pcoItemDados.id_vei_modelo"></span>
                      </template>

                      <!-- COLOCA O MODELO ANTIGO DA API-->
                      <template v-else>
                        <span v-if="[ '', null, undefined ].indexOf(pcoItemDados.id_vei_marca_antigo) === -1" v-html="' ' + pcoItemDados.id_vei_marca_antigo"></span>
                        <span v-if="[ '', null, undefined ].indexOf(pcoItemDados.id_vei_modelo_antigo) === -1" v-html="' ' + pcoItemDados.id_vei_modelo_antigo"></span>
                      </template>

                      <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                      <b v-if='pcoItemDados.id_vei_status !== "1"' v-html="'[Excluído]'"></b>
                    </template>
                  </RF-Button>   
                </td>
              </tr>
            
              <tr v-if="[ '', null, undefined ].indexOf(pcoItemDados.item_nome) === -1">
                <td>
                  Tipo:
                  <div class="font-tp-1">
                    Produto
                  </div>
                </td>
                <td colspan="2">
                  Item:
                  <RF-Button class="bt-link-cadastro font-tp-1"
                    :cpntId='"RF-Tabela-Vue--link-" + $route.params.tipo + "s--" + pcoItemDados.item_id'
                    :cpntStatus='""'
                    :cpntTipo='"texto"'
                    :cpntClass='[ "btn", "btn-default" ]'

                    @onClickButton='pcoPainelFormInformacoesCadastro'>
                    <template slot="conteudo">
                      <!-- COLOCA O NOME DO CONTATO -->
                      <span v-html="pcoItemDados.item_nome"></span>

                      <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                      <b v-if='pcoItemDados.item_status !== "1"' v-html="'[Excluído]'"></b>
                    </template>
                  </RF-Button>
                </td>
              </tr>

              <tr>
                <td>
                  Última Alteração:
                  <div class="font-tp-1" v-if="[ '', null, undefined ].indexOf(pcoItemDados.tempo) === -1" v-html="pcoItemDados.tempo"></div>
                  <div v-else>&nbsp;</div>
                </td>
                <td>
                  Alterado por:
                  <div class="font-tp-1" v-if="[ '', null, undefined ].indexOf(pcoItemDados.last_user_usuario) === -1" v-html="pcoItemDados.last_user_usuario"></div>
                </td>
                <td>
                  Lista de Status
                  <div class="font-tp-1" v-if="[ '', null, undefined ].indexOf(formulario.field.status.value) === -1" v-html="formulario.field.status.options.filter(item => item.id === formulario.field.status.value)[0].id_pco_status_item_id_pco_status_nome"></div>
                </td>
                <!-- <td v-if="[ '', null, undefined ].indexOf(formulario.field.status) === -1">
                  Status:
                  <RF-Componente
                    :data-time='time'
                    :cpntTamanho='formulario.field.status.tamanho'
                    :cpntModelo='formulario.field.status.tipo'
                    :cpntStatus='formulario.field.status.status'
                    :cpntId='formulario.field.status.id'
                    :cpntClassDivField='formulario.field.status.classDivField'
                    :cpntNome='""'
                    :cpntValue='formulario.field.status.value'
                    :cpntValueRef='formulario.field.status.valueRef'
                    :cpntOptions='formulario.field.status.options'
                    :cpntKeyValue='formulario.field.status.keyValue'
                    :cpntKeyMostra='formulario.field.status.keyMostra'
                    :cpntSearchMinimo='formulario.field.status.searchMinimo'
                    :cpntAutoComplete='formulario.field.status.autocomplete'
                    :cpntDisabled='formulario.field.status.disabled'
                    :cpntMostrar='formulario.field.status.mostrar'
                    :cpntMensagem='formulario.field.status.mensagem'
                    :cpntSelecioneNome='formulario.field.status.selecioneNome'
                    :cpntSelecioneValue='formulario.field.status.selecioneValue'
                    :cpntMensagemTipo='formulario.field.status.mensagemTipo'
                    :cpntAdicinarOption='formulario.field.status.adicinarOption'
                    :cpntMultiple='formulario.field.status.multiple'
                    :cpntAllRegistro='formulario.field.status.allRegistro'
                    :cpntExplica='formulario.field.status.explica'
                    :cpntTabIndex='formulario.field.status.tabIndex'
                    :cpntOptionInicialNome='formulario.field.status.optionInicialNome'
                    :cpntOptionInicialValue='formulario.field.status.optionInicialValue'

                    :cpntOnChange='formulario.field.status.onChange'
                    :cpntOnBlur='formulario.field.status.onBlur'
                    :ref='"status"'
                  ></RF-Componente>
                </td> -->
              </tr>

              <tr>
                <td colspan="4" style="padding: 10px 5px; text-align: center;">
                  <div style="display: inline-block; text-align: left;" v-if="[ '', null, undefined ].indexOf(formulario.field.status) === -1">
                    Status:
                    <RF-Componente
                      :data-time='time'
                      :cpntTamanho='formulario.field.status.tamanho'
                      :cpntModelo='formulario.field.status.tipo'
                      :cpntStatus='formulario.field.status.status'
                      :cpntId='formulario.field.status.id'
                      :cpntClassDivField='formulario.field.status.classDivField'
                      :cpntNome='""'
                      :cpntValue='formulario.field.status.value'
                      :cpntValueRef='formulario.field.status.valueRef'
                      :cpntOptions='formulario.field.status.options'
                      :cpntKeyValue='formulario.field.status.keyValue'
                      :cpntKeyMostra='formulario.field.status.keyMostra'
                      :cpntSearchMinimo='formulario.field.status.searchMinimo'
                      :cpntAutoComplete='formulario.field.status.autocomplete'
                      :cpntDisabled='formulario.field.status.disabled'
                      :cpntMostrar='formulario.field.status.mostrar'
                      :cpntMensagem='formulario.field.status.mensagem'
                      :cpntSelecioneNome='formulario.field.status.selecioneNome'
                      :cpntSelecioneValue='formulario.field.status.selecioneValue'
                      :cpntMensagemTipo='formulario.field.status.mensagemTipo'
                      :cpntAdicinarOption='formulario.field.status.adicinarOption'
                      :cpntMultiple='formulario.field.status.multiple'
                      :cpntAllRegistro='formulario.field.status.allRegistro'
                      :cpntExplica='formulario.field.status.explica'
                      :cpntTabIndex='formulario.field.status.tabIndex'
                      :cpntOptionInicialNome='formulario.field.status.optionInicialNome'
                      :cpntOptionInicialValue='formulario.field.status.optionInicialValue'

                      :cpntOnChange='formulario.field.status.onChange'
                      :cpntOnBlur='formulario.field.status.onBlur'
                      :ref='"status"'
                    ></RF-Componente>
                  </div>
                  <div style="display: inline-block; margin-left: 10px; vertical-align: bottom;">
                    <RF-Button
                      :data-time='time'

                      :cpntStatus='""' 
                      :cpntId='formulario.buttonAdd.id + "-add-obs"' 
                      :cpntTipo='"texto"' 
                      :cpntTexto='"Adicionar observação"' 
                      :cpntClass='[ "btn", "btn-info", "btn-sm" ]'

                      @onClickButton='pcoPainelFormObservacaoMostrar'
                    ></RF-Button>
                  </div>
                </td>
              </tr>

              <!-- <tr v-if="[ '', null, undefined ].indexOf(formulario.field.obs) === -1">
                <td colspan="4" style="padding-top: 20px; text-align: center;">
                  <RF-Componente style="display: inline-block;"
                    :data-time='time'
                    :cpntTamanho='formulario.field.obs.tamanho'
                    :cpntModelo='formulario.field.obs.tipo'
                    :cpntStatus='formulario.field.obs.status'
                    :cpntId='formulario.field.obs.id'
                    :cpntClassDivField='formulario.field.obs.classDivField'
                    :cpntNome='formulario.field.obs.nome'
                    :cpntValue='formulario.field.obs.value'
                    :cpntValueRef='formulario.field.obs.valueRef'
                    :cpntOptions='formulario.field.obs.options'
                    :cpntKeyValue='formulario.field.obs.keyValue'
                    :cpntKeyMostra='formulario.field.obs.keyMostra'
                    :cpntSearchMinimo='formulario.field.obs.searchMinimo'
                    :cpntAutoComplete='formulario.field.obs.autocomplete'
                    :cpntDisabled='formulario.field.obs.disabled'
                    :cpntMostrar='formulario.field.obs.mostrar'
                    :cpntMensagem='formulario.field.obs.mensagem'
                    :cpntSelecioneNome='formulario.field.obs.selecioneNome'
                    :cpntSelecioneValue='formulario.field.obs.selecioneValue'
                    :cpntMensagemTipo='formulario.field.obs.mensagemTipo'
                    :cpntAdicinarOption='formulario.field.obs.adicinarOption'
                    :cpntMultiple='formulario.field.obs.multiple'
                    :cpntAllRegistro='formulario.field.obs.allRegistro'
                    :cpntExplica='formulario.field.obs.explica'
                    :cpntTabIndex='formulario.field.obs.tabIndex'
                    :cpntOptionInicialNome='formulario.field.obs.optionInicialNome'
                    :cpntOptionInicialValue='formulario.field.obs.optionInicialValue'
                    :cpntConfig='formulario.field.obs.config'

                    :cpntOnChange='formulario.field.obs.onChange'
                    :cpntOnBlur='formulario.field.obs.onBlur'
                    :ref='"obs"'
                  ></RF-Componente>
                  <div style="    display: inline-block; vertical-align: 60px; padding-left: 20px;">
                    <RF-Button v-if="[ '', null, undefined ].indexOf(formulario.buttonAdd) === -1" style="margin-left: 10px; vertical-align: 30px;"
                      :data-time='time'

                      :cpntStatus='formulario.buttonAdd.status' 
                      :cpntId='formulario.buttonAdd.id + "0"' 
                      :cpntTipo='"texto"' 
                      :cpntIcone='formulario.buttonAdd.icone' 
                      :cpntTexto='"Adicionar"' 
                      :cpntClass='formulario.buttonAdd.class'
                      :cpntMostrar='formulario.buttonAdd.mostrar'
                      :cpntTabIndex='formulario.buttonAdd.tabIndex'

                      @onClickButton='formulario.buttonAdd.onClick'
                    ></RF-Button>
                  </div>
                </td>
              </tr> -->
            </table>
          </template>

          <div v-if="pcoItemHistorico.length >= 1">
            <table :data-time="time" class="pco-painel-form">
              <caption style="text-align: center;">
                <i aria-hidden="true" class="fa fa-angle-double-right"></i> HISTÓRICO DO PROCESSO <i aria-hidden="true" class="fa fa-angle-double-left"></i>
              </caption>
              <tbody>
                <tr v-for="(historico, indexH) in pcoItemHistorico" :key="'his-' + indexH" :style="([ '', null, undefined ].indexOf(historico.id_pco_item_id_pco_status_item_cor_fundo) === -1 ? (' background: ' + historico.id_pco_item_id_pco_status_item_cor_fundo + ';') : '') + ([ '', null, undefined ].indexOf(historico.id_pco_item_id_pco_status_item_cor_letra) === -1 ? (' color: ' + historico.id_pco_item_id_pco_status_item_cor_letra + ';') : '')">
                  <td class="obs" style="width: 250px;">
                    <div>
                      <!-- ADICIONA A ALTERAÇÃO -->
                      <div v-html="'Alterado por ' + historico.last_user_usuario + ' em ' + historico.data_hora_ptbr + ': '"></div>

                      <!-- ADICIONA A OBSERVAÇÃO -->
                      <div v-html="historico.id_pco_item_id_pco_status_item_nome"></div>
                    </div>
                  </td>
                  <!-- <td class="nome">
                    <span v-html="historico.id_pco_item_id_pco_status_item_nome"></span>
                  </td> -->
                  <td class="obs">
                    <template v-if="historico.obs.length >= 1">
                      <div v-for="(obs, indexO) in historico.obs" :key="'his-' + indexH + '-obs-' + indexO">
                        <!-- ADICIONA A ALTERAÇÃO -->
                        <div v-html="'Inserido por ' + obs.last_user_usuario + ' em ' + obs.last_at_ptbr + ': '"></div>

                        <!-- ADICIONA A OBSERVAÇÃO -->
                        <div v-html="obs.observacao"></div>
                      </div>
                    </template>
                    <div v-else style="text-align: center;">---</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </template>
    </RF-Dialog>

    <template v-if="Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1 && [ '', null, undefined ].indexOf(formulario.field.obs) === -1">
      <RF-Dialog v-if="observacao === true"
      :cpntStatus='formulario.field.obs.status'
      :cpntLargura='"592px"'
      :cpntTitulo='"Inserir Observação"'

      :cpntOnFecharDialog='pcoPainelFormObservacaoMostrar'>
        <template slot='conteudo'>
          <div style="padding-top: 30px;">
            <RF-Componente
              :data-time='time'
              :cpntTamanho='formulario.field.obs.tamanho'
              :cpntModelo='formulario.field.obs.tipo'
              :cpntStatus='""'
              :cpntId='formulario.field.obs.id'
              :cpntClassDivField='formulario.field.obs.classDivField'
              :cpntNome='formulario.field.obs.nome'
              :cpntValue='formulario.field.obs.value'
              :cpntValueRef='formulario.field.obs.valueRef'
              :cpntOptions='formulario.field.obs.options'
              :cpntKeyValue='formulario.field.obs.keyValue'
              :cpntKeyMostra='formulario.field.obs.keyMostra'
              :cpntSearchMinimo='formulario.field.obs.searchMinimo'
              :cpntAutoComplete='formulario.field.obs.autocomplete'
              :cpntDisabled='formulario.field.obs.disabled'
              :cpntMostrar='formulario.field.obs.mostrar'
              :cpntMensagem='formulario.field.obs.mensagem'
              :cpntSelecioneNome='formulario.field.obs.selecioneNome'
              :cpntSelecioneValue='formulario.field.obs.selecioneValue'
              :cpntMensagemTipo='formulario.field.obs.mensagemTipo'
              :cpntAdicinarOption='formulario.field.obs.adicinarOption'
              :cpntMultiple='formulario.field.obs.multiple'
              :cpntAllRegistro='formulario.field.obs.allRegistro'
              :cpntExplica='formulario.field.obs.explica'
              :cpntTabIndex='formulario.field.obs.tabIndex'
              :cpntOptionInicialNome='formulario.field.obs.optionInicialNome'
              :cpntOptionInicialValue='formulario.field.obs.optionInicialValue'
              :cpntConfig='formulario.field.obs.config'

              :cpntOnChange='formulario.field.obs.onChange'
              :cpntOnBlur='formulario.field.obs.onBlur'
              :ref='"obs"'
            ></RF-Componente>
            <div style="text-align: center; padding-top: 15px;">
              <RF-Button v-if="[ '', null, undefined ].indexOf(formulario.buttonAdd) === -1"
                :data-time='time'

                :cpntStatus='formulario.buttonAdd.status' 
                :cpntId='formulario.buttonAdd.id + "0"' 
                :cpntTipo='"texto"' 
                :cpntIcone='formulario.buttonAdd.icone' 
                :cpntTexto='"Adicionar"' 
                :cpntClass='formulario.buttonAdd.class'
                :cpntMostrar='formulario.buttonAdd.mostrar'
                :cpntTabIndex='formulario.buttonAdd.tabIndex'

                @onClickButton='formulario.buttonAdd.onClick'
              ></RF-Button>
            </div>
          </div>
        </template>
      </RF-Dialog>
    </template>
  </div>
</template>

<style scoped>
.font-tp-1 {
  font-weight: bold;
  opacity: 0.8;
  text-shadow: none;
}

table {
  width: 100%;
}
  table > tr > td {
    text-align: left;
    padding: 0px 10px;
    width: calc(100% / 3);
  }
    table > tr > td > .font-tp-1 {
      width: auto !important;
      display: block;
      text-align: left;
      padding: 2px 0px;
      margin: 0px;
    }
    table > tr > td > button.font-tp-1,
    table > tr > td > button.font-tp-1:active,
    table > tr > td > button.font-tp-1:hover {
      background: none;
      text-decoration: underline;
      box-shadow: none;
    }

.pco-painel-form,
.pco-painel-form > caption {
  background: #e9e9e9;
}
.pco-painel-form > caption {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-weight: bold;
  color: #444;
  margin-bottom: -15px;
}
.pco-painel-form {

  padding: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;

  margin: 0px 0px;
  border-collapse: separate;
  border-spacing: 0px 5px;
  text-shadow: none;
}
  .pco-painel-form > tbody > tr > td:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .pco-painel-form > tbody > tr > td:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .pco-painel-form > tbody > tr > td {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
    .pco-painel-form > tbody > tr > td:first-child {
      border-left: 1px solid #ccc;
    }
    .pco-painel-form > tbody > tr > td {
      border-right: 1px solid #ccc;
      padding: 5px;
    }

.nome {
  min-width: 165px;
  text-align: left;
}
.obs {
  text-align: left;
  vertical-align: top;
}
  .obs > div:not(:first-child) {
    margin-top: 7px;
  }
  .obs > div > div:first-child {
    font-size: var(--font-base-soma-09);
  }
  .obs > div > div:last-child {
    padding-top: 2px;
    padding-left: 5px;
  }
  .obs > button {
    width: 20px;
    height: 20px;
    padding: 0px;
    margin: 0px;
    text-align: center;
    vertical-align: middle;
    margin-right: -5px;
    margin-top: -7px;
  }
.usuario {
  width: 120px;
  text-align: center;
}
.data {
  width: 120px;
  text-align: center;
}


.campos {
  margin-top: 20px;
}
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntTipo: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        atualizar: false,
        finaliza: [],
        registro: '',
        formulario: {},
        pcoItemDados: {},
        pcoItemHistorico: [],
        registroTipo: '',
        observacao: false
      }
    },
    mounted: function () {
      this.pcoPainelFormIniciar()
    },
    methods: {
      pcoPainelFormIniciar: function () {
        var self = this

        // SETA O STATUS DA TELA
        self.pcoPainelFormSetaStatusGeral('carregando')
        
        // REINICIA TODOS OS CAMPOS
        self.finaliza = []
        self.registro = ''
        self.formulario = {}
        self.pcoItemDados = {}
        self.pcoItemHistorico = []

        // RESETA OS REGISTROS DA TELA
        self.registro = ''
        self.registroTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // VERIFICA SE O CAMPO FOI INFORMADO
        if ([ '', null, undefined ].indexOf(self.cpntId) === -1 && [ '', null, undefined ].indexOf(self.cpntTipo) === -1) {
          self.registro = self.cpntId
          self.registroTipo = self.cpntTipo
        } else if ([ 'pco_painel_form' ].indexOf(self.$route.name) !== -1) {
          self.registro = self.$route.params.id
          self.registroTipo = self.$route.params.tipo
        }

        if (self.registro !== '' && self.registroTipo !== '') {
          // INICIA OS DADOS
          self.pcoItemDados = {}

          // CARREGA OS DADOS DAS VENDAS
          if (self.registroTipo === 'venda') {
            self.pcoPainelFormCarregarDadosVenda(self.registro)
          } else {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'selecionado', o: '=', v: '1' } ] } }

            switch (self.registroTipo) {
              case 'servico':
                queryGet.where.aAnd.push({ f: 'id_ven_ser', o: '=', v: self.registro })
                queryGet.field = { id_ven_ser: { j: { cod_venda: { a: 'vendaId' }, id_ser: { j: { id: { a: 'item_id' },  nome: { a: 'item_nome' }, status: { a: 'item_status' } } } } } }
                break

              case 'produto':
                queryGet.where.aAnd.push({ f: 'id_ven_pro', o: '=', v: self.registro })
                queryGet.field = { id_ven_pro: { j: { cod_venda: { a: 'vendaId' }, id_pro: { j: { id: { a: 'item_id' },  nome: { a: 'item_nome' }, status: { a: 'item_status' } } } } } }
                break
            }

            // FAZ A BUSCA NA API
            self.$store.state.comunicaAPI('/con-processo/get', 'POST', queryGet, function (apiSuccess) {
              if (apiSuccess.data.length === 1) {
                // SETA OS DADOS RECEBIDOS
                self.pcoItemDados = Object.assign(self.pcoItemDados, apiSuccess.data[0])

                // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS DA VENDA
                self.pcoPainelFormCarregarDadosVenda(apiSuccess.data[0].vendaId)
              }
            }, self.pcoPainelFormSetaStatusGeral)
          }

          // CARREGA O HISTORICO DOS PROCESSOS
          self.pcoPainelFormCarregarHistorico()
        } else {
          // SETA O STATUS DA TELA
          self.pcoPainelFormSetaStatusGeral({ loc: 'WEB', cod: 500, err: 'Erro ao identificar registro ou o tipo de registro.' })
        }
      },
      pcoPainelFormSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoPainelFormFinalizar: function (funcao) {
        // SALVA A CONTAGEM DE FINALIZAÇÕES
        this.finaliza.push(funcao)

        // REMOVER VALORES DUPLICADOS
        this.finaliza = this.finaliza.filter((v, i, a) => a.indexOf(v) === i)

        // CHAMA A FUNÇÃO PARA BUSCAS OS DADOS DAS VENDAS
        if (this.finaliza.length === 4) {
          // SETA FOCUS NO CAMPO INICIAL
          this.pcoPainelFormFocusCampo(this, 'obs')

          // SETA O STATUS DA TELA
          this.pcoPainelFormSetaStatusGeral('')
        }
      },
      pcoPainelFormFocusCampo: function (self, campo, tentativa = 0) {
        // VERIFICA SE O CAMPO EXISTE
        var encontrado = Object.keys(self.$refs).length >= 1 && [ '', null, undefined ].indexOf(self.$refs[campo]) === -1

        // VERFICA SE ENCONTRA O CAMPO INFORMADO PARA REALIZAR FOCUS
        if (encontrado === true) {
          encontrado = Object.keys(self.$refs[campo].$refs).length >= 1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs.textarea) === -1
        }

        // VERIFICA SE O CAMPO FOI ENCONTRADO
        if (encontrado === false && tentativa <= 10) {
          setTimeout(function () {
            self.pcoPainelFormFocusCampo(self, campo, (tentativa + 1))
          }, 200)
        } else if (tentativa <= 10 && encontrado === true) {
          self.$refs[campo].$refs.textarea.onFocusField()
        }
      },
      pcoPainelFormFechar: function (atualizar, id = null, dados = null) {
        // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
        if ([ '', null, undefined ].indexOf(this.cpntFecharFormulario) === -1) {
          this.cpntFecharFormulario(this.atualizar, id, dados)
        }

        // VERIFICA SE DEVE MUDAR A ROTA DO VUE
        if (this.cpntId === null) {
          this.$router.push({ name: 'pco_painel', params: {} })
        }
      },
      pcoPainelFormObservacaoMostrar: function () {
        // SETA SE DEVE OU NÃO MOSTRAR OS CAMPOS DE OBSERVAÇÃO
        this.observacao = !this.observacao
        
        // LIMPA OS DADOS DO CAMPO OBSERVAÇÃO
        this.formulario.field.obs.value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE DAR O FOCUS NO CAMPO
        if (this.observacao === true) {
          this.pcoPainelFormObservacaoFocus(this)
        }
      },
      pcoPainelFormObservacaoFocus: function (self, tentativa = 0) {
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(self.$refs) === -1 && [ '', null, undefined ].indexOf(self.$refs.obs) === -1 && [ '', null, undefined ].indexOf(self.$refs.obs.$refs) === -1 && [ '', null, undefined ].indexOf(self.$refs.obs.$refs.ckeditor) === -1) {
            self.$refs.obs.$refs.ckeditor.onFocusField()
          } else {
            setTimeout(function () { self.pcoPainelFormObservacaoFocus(self, (tentativa + 1)) }, 500)
          }
        }
      },

      pcoPainelFormCarregarDadosVenda: function (vendaId) {
        var self = this

        // MONTA A PESQUINA NA API
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { aAnd: [ { f: 'cod_venda', o: '=', v: vendaId } ] } }

        // SETA OS CAMPOS QUE DEVE RETORNAR
        queryGet.field = {
          cod_venda: null,
          vencimento: null,
          dt_ent: null,
          status: null,

          id_pco_item: { a: 'id_pco_status_item_id' }, 

          id_pet: { j: { nome: null, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } }, status: null } },
          id_vei: { j: { placa: null, id_mar: { j: { nome: { a: 'id_vei_marca_antigo' } } }, id_mod: { j: { nome: { a: 'id_vei_modelo_antigo' } } }, ref_modelo: { j: { j_modelo: { a: 'id_vei_modelo' } } }, status: null } },
          id_con: { j: { nome: null, empresa: null, cnpj_cpf: null, pessoa: null, pj_sn: null, status: null } }
        }

        self.$store.state.comunicaAPI('/venda/get', 'POST', queryGet, function (apiSuccess) {
          // SETA OS DADOS RECEBIDOS
          self.pcoItemDados = Object.assign(self.pcoItemDados, apiSuccess.data[0])

          // CHAMA A FUNÇÃO PARA SETAR QUE FOI FINALIZADO O PROCESSO DESTA FUNÇÃO
          self.pcoPainelFormFinalizar('pcoPainelFormCarregarDadosVenda')
        }, self.pcoPainelFormSetaStatusGeral)
      },
      pcoPainelFormCarregarHistorico: function () {
        var self = this

        // // LIMPA OS DADOS
        // self.pcoItemHistorico = []

        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { aAnd: [ { m: 'pco_item_tempo', f: 'status', o: '=', v: '1' } ] }, order: { data_hora: 'desc' } }

        // SETA OS CAMPO QUE DEVEM SER RETORNADO
        queryGet.field = {
          id: null,
          id_pco_item: { j: { id_pco_status_item: { j: { nome: null, cor: { a: 'id_pco_item_id_pco_status_item_cor_fundo' } } } } },
          last_user: { j: { usuario: null } },
          data_hora: null
        }

        switch (self.registroTipo) {
          case 'venda':
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'cod_venda', o: '=', v: self.registro })
            break

          case 'servico':
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'id_ven_ser', o: '=', v: self.registro })
            break

          case 'produto':
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'id_ven_pro', o: '=', v: self.registro })
            break
        }

        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/con-processo/tempo/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA OS DADOS RECEBIDOS DA API
          self.pcoItemHistorico = apiSuccess.data

          // INICIA OS VETOR DE IDS
          var ids = []

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

          // ADICIONA TODOS OS IDS RECEBIDOS NO VETOR
          for (var key in self.pcoItemHistorico) {
            // SETA O ID DO CAMPO
            ids.push(self.pcoItemHistorico[key].id)

            // CALCULA A COR DA LETRA
            self.pcoItemHistorico[key].id_pco_item_id_pco_status_item_cor_letra = FUN_VERIFICA_COR_LETRA(self.pcoItemHistorico[key].id_pco_item_id_pco_status_item_cor_fundo)

            // INICIA A VARIAVEL QUE VAI RECEBER OS DADOS
            self.pcoItemHistorico[key].obs = []
          }

          if (self.pcoItemHistorico.length >= 1) {
            
            // SETA O ULTIMO REGISTRO RECEBIDO
            self.pcoItemDados = Object.assign(self.pcoItemDados, self.pcoItemHistorico[0])

            // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
            const FUN_CRIAR_FRASE_TEMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_CRIAR_FRASE_TEMPO

            // MONSTA A FRASE DO TEMPO
            self.pcoItemDados.tempo = FUN_CRIAR_FRASE_TEMPO(self.pcoItemDados.data_hora_ptbr, '', '')

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // INICIA OS FORMULARIOS SE ELE NÃO FOI INICIADO
            if (Object.keys(self.formulario).length === 0 || self.formulario.field.status.valueIni !== self.formulario.field.status.value) {  
              self.pcoPainelFormFormularioIniciar()
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA SETAR QUE FOI FINALIZADO O PROCESSO DESTA FUNÇÃO
          self.pcoPainelFormFinalizar('pcoPainelFormCarregarHistorico')

          // CHAMA A FUNÇÃO PARA CARREGAR AS OBSERVAÇÕES DE CADA LINHA
          self.pcoPainelFormCarregarObservacoes(ids)
        }, self.pcoPainelFormSetaStatusGeral)
      },
      pcoPainelFormCarregarObservacoes: function (ids, qtde = 350, ini = null, fim = null) {
        var self = this

        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // MONTA A PESQUINA NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pco_item_tempo', o: 'in', v: ids.slice(ini, fim).join() } ] }, order: { last_at: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null,
            id_pco_item_tempo: null,
            observacao: null,
            last_user: { j: { usuario: null } },
            last_at: null
          }

          self.$store.state.comunicaAPI('/con-processo/observacao/get/', 'GET', queryGet, function (apiSuccess) {
            // ADICIONA OS VALORES RECEBIDOS NAS LINHAS
            for (var key in apiSuccess.data) {
              // PEGA O NUMERO DA LINHA
              var index = self.pcoItemHistorico.findIndex(item => item.id === apiSuccess.data[key].id_pco_item_tempo)

              // ADICIONA OS VALORES RECEBIDOS A LINHA
              self.pcoItemHistorico[index].obs.push(apiSuccess.data[key])
            }

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            self.pcoPainelFormCarregarObservacoes(ids, qtde, ini, fim)
          }, self.pcoPainelFormSetaStatusGeral)
        } else {
          // CHAMA A FUNÇÃO PARA SETAR QUE FOI FINALIZADO O PROCESSO DESTA FUNÇÃO
          self.pcoPainelFormFinalizar('pcoPainelFormCarregarObservacoes')
        }
      },
      
      // FUNÇÕES DE CADASTRO ADICIONAIS DO SISTEMA
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      pcoPainelFormInformacoesCadastro: function (id) {
        // PEGA OS DADOS RECEBIDOS NO ID
        var index = id.split('--')

        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO' }

        // PEGA O TIPO DE REGISTRO QUE ESTA SENDO TRABALHADO
        switch (index[1]) {
          case 'link-contato':
            params.tipo = 'contato'
            break

          case 'link-veiculo':
            params.tipo = 'veiculo'
            break

          case 'link-pet':
            params.tipo = 'pet'
            break

          case 'link-produtos':
            params.tipo = 'produto'
            break

          case 'link-servicos':
            params.tipo = 'servico'
            break
        }

        // SETA O ID RECEBIDO
        params.id = index[2]

        switch (index[1]) {
          case 'link_venda':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'venda', id: params.id, tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
            break

          default:
            // SETA A FUNÇÃO CALLBACK
            params.callback = this.pcoPainelInformacoesCadastroFechar
    
            // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
            this.$store.commit('SET_ABRIR_CADASTRO', params)
            break
        }
      },
      pcoPainelInformacoesCadastroFechar: function (atualizar) {
        if (atualizar === true) {
          // CHAMA A FUNÇÃO INICIAR TODO O PROCESSO NOVAMENTE
          this.pcoPainelFormIniciar()
        }
      },

      pcoPainelFormFormularioAdicionarComentario: function (id) {
        var self = this

        // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
        self.formulario.buttonAdd.status = 'carregando'

        // PEGA O ID DO REGISTRO QUE ESTA SENDO TRABALHANDO
        var index = id.split('--')[1]
        
        // SE O VALOR FOR ZERO, ATUALIZA PARA O ID CORRETO
        if (index === '0') {
          index = self.pcoItemHistorico[0].id
        }

        // MONTA O FORMULARIO QUE SERTÁ ENVIADO PARA API
        var formData = { id_pco_item_tempo: index, observacao: self.formulario.field.obs.value }

        // CONVERTE PARA CHAVE LOT
        formData = { lot: [ formData ] }

        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/con-processo/observacao', 'POST', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // LIMPA O VALOR DO CAMPO APÓS SALVAR
            self.formulario.field.obs.value = ''

            // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
            self.formulario.buttonAdd.status = ''

            // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()

            // CARREGA O HISTORICO DOS PROCESSOS
            self.pcoPainelFormCarregarHistorico()

            // SETA O STATUS SE DEVE OU NÃO ATUALIZAR A TELA ATRAS
            self.atualizar = true

            // CHAMA A FUNÇÃO PARA FECHAR DIALOG DE OBSERVAÇÃO
            self.pcoPainelFormObservacaoMostrar()
          })
        }, self.pcoPainelFormSetaStatusGeral, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form) {
            // SETA OS CAMPOS COM OS ERROS
            self.formulario.field = form

            // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
            self.formulario.buttonAdd.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        })
      },
      pcoPainelFormAlterarStatus: function () {
        var self = this

        if (self.formulario.field.status.valueIni !== self.formulario.field.status.value) {
          // MONTA O FORMULARIO QUE SERTÁ ENVIADO PARA API
          var formData = { id: self.formulario.field.status.value }
  
          // CONVERTE PARA CHAVE LOT
          formData = { lot: [ formData ] }
  
          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/con-processo', 'PUT', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // LIMPA O VALOR DO CAMPO APÓS SALVAR
              self.formulario.field.obs.value = ''

              // ATUALIZA O VALOR INICIAL
              self.formulario.field.status.valueIni = self.formulario.field.status.value
  
              // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ATUALIZAR AS TELA DEPENDENTES
              if ([ '', null, undefined ].indexOf(self.cpntFecharFormulario) === -1) {
                self.atualizar = true
              }
  
              // CARREGA O HISTORICO DOS PROCESSOS
              self.pcoPainelFormCarregarHistorico()
            })
          }, self.pcoPainelFormSetaStatusGeral, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form) {
              // SETA OS CAMPOS COM OS ERROS
              self.formulario.field = form
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        }
      },
      pcoPainelFormFormularioIniciar: function () {
        var self = this

        // INICIA OS DADOS DO FORMULARIO
        self.formulario = {
          id: 'pco-painel-form',
          field: {},
          buttonAdd: {
            status: '',
            id: 'pco-painel-form-comentario--',
            tipo: 'icone',
            icone: { tipo: 'ico-mais' },
            class: 'btn btn-default btn-sm',
            onClick: self.pcoPainelFormFormularioAdicionarComentario 
          }
        }

        // SETA O CAMPO CATEGORIA
        self.formulario.field.status = {
          tamanho: 2,
          tipo: 'select2',
          nome: 'Status',
          id: self.formulario.id + '--status',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: '',
          searchMinimo: 100000,
          onChange: self.pcoPainelFormFormularioOnChangeValue
        }

        // SETA O CAMPO CATEGORIA
        self.formulario.field.obs = {
          tamanho: 70,
          tipo: 'ckeditor',
          nome: 'Observação',
          id: self.formulario.id + '--obs',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          config: {
            removeButtons: 'Save,NewPage,Preview,Print,Templates,About,ShowBlocks,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,Subscript,Superscript,Blockquote,CreateDiv,Outdent,Indent,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Styles,Format',
            toolbarGroups: [
              { name: 'tools', groups: [ 'tools' ] },
              { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
              { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
              { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
              { name: 'forms', groups: [ 'forms' ] },
              { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
              { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
              { name: 'links', groups: [ 'links' ] },
              { name: 'insert', groups: [ 'insert' ] },
              { name: 'styles', groups: [ 'styles' ] },
              { name: 'colors', groups: [ 'colors' ] },
              { name: 'others', groups: [ 'others' ] },
              { name: 'about', groups: [ 'about' ] }
            ],
            height: '100'
          },
          onChange: self.pcoPainelFormFormularioOnChangeValue
        }

        self.pcoPainelFormFormularioCarregarOpcoesStatus(function () {
          // SETA O VALOR INICIAL SELECIONADO
          self.formulario.field.status.value = self.pcoItemDados.id_pco_item
          self.formulario.field.status.valueIni = self.pcoItemDados.id_pco_item

          // CHAMA A FUNÇÃO PARA SETAR QUE FOI FINALIZADO O PROCESSO DESTA FUNÇÃO
          self.pcoPainelFormFinalizar('pcoPainelFormFormularioIniciar')
        })
      },
      pcoPainelFormFormularioCarregarOpcoesStatus: function (callback = null) {
        var self = this

        // INICIA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, id_ven_pro: null, id_pco_status_item: { j: { nome: { a: 'nome' }, cor: { a: 'cor' }, posicao: null, id_pco_status: { j: { nome: null } } } }, selecionado: null } }

        // SETA O REGISTRO DE QUAL VENDA ESTA SENDO BUSCADO
        queryGet.where = { aAnd: [ { m: 'pco_item', f: 'status', o: '=', v: '1' } ] }

        switch (self.registroTipo) {
          case 'venda':
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'cod_venda', o: '=', v: self.registro })
            break

          case 'servico':
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'id_ven_ser', o: '=', v: self.registro })
            break

          case 'produto':
            queryGet.where.aAnd.push({ m: 'pco_item', f: 'id_ven_pro', o: '=', v: self.registro })
            break
        }

        // SETA A ORDENAÇÃO QUE DEVE REALIZAR
        queryGet.order = { id_pco_status_item_posicao: 'asc' }

        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/con-processo/get', 'POST', queryGet, function (apiSuccess) {
          // PEGA O NUMERO DA LINHA
          self.formulario.field.status.options = apiSuccess.data

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null) [
            callback()
          ]
        }, self.pcoPainelFormSetaStatusGeral)
      },
      pcoPainelFormFormularioOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.formulario.field[index[1]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index[1]].mensagem = ''
        this.formulario.field[index[1]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index[1]) {
          case 'status':
            this.pcoPainelFormAlterarStatus()
            break
        }
      }
    }
  }
</script>
